import { UtilsService } from "../utils";
import { authorizedAPI } from "@/config/axios.config";

const utils = new UtilsService();

export interface GetAllApplicationsOptions {
  page?: number;
  limit?: number;
  search?: string;
}

export interface GetApplicationsForProcessOptions {
  page?: number;
  limit?: number;
  search?: string;
}

class IncomingService {
  getAllApplications(
    type: 'pending' | 'completed' | 'disabled' | 'processed',
    isAdmin: boolean = false,
    options?: GetAllApplicationsOptions
  ): Promise<any> {
    const params = new URLSearchParams();
    params.append('type', type);
    if (isAdmin) params.append('admin', 'true');
    if (options?.page) params.append('page', String(options.page));
    if (options?.limit) params.append('limit', String(options.limit));
    if (options?.search?.trim()) params.append('search', options.search.trim());
    const queryString = params.toString();

    return utils.handleApiRequest(() =>
      authorizedAPI.get(`/incoming-applications?${queryString}`)
    );
  }

  getApplicationsForProcess(
    processId: string,
    type: 'pending' | 'completed' | 'disabled' | 'processed',
    isAdmin: boolean = false,
    status?: string,
    options?: GetApplicationsForProcessOptions
  ): Promise<any> {
    const params = new URLSearchParams();
    params.append('type', type);
    if (isAdmin) params.append('admin', 'true');
    if (status) params.append('status', status);
    if (options?.page) params.append('page', String(options.page));
    if (options?.limit) params.append('limit', String(options.limit));
    if (options?.search?.trim()) params.append('search', options.search.trim());
    const queryString = params.toString();

    return utils.handleApiRequest(() =>
      authorizedAPI.get(`/incoming-applications/process/${processId}?${queryString}`)
    );
  }

  // 3. Get single application details
  getSingleApplication(applicantProcessId: string, type?: 'pending' | 'completed' | 'disabled' | 'processed'): Promise<any> {
    return utils.handleApiRequest(() =>
      authorizedAPI.get(`/incoming-applications/single/${applicantProcessId}`, { params: type ? { type } : {} })
    );
  }
}

export const incomingService = new IncomingService();